module.exports = __webpack_public_path__ + "fc0132f8765d75d7ca7efa4aa02ae842.png";